"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const EID_BASE = 'find.sales.';
const EID_AI = 'ai_domain_search_spins.';
var _default = exports.default = {
  Domain: {
    Spins: `${EID_BASE}domain_spins`,
    SpinsByEndings: `${EID_BASE}domain_spins_byendings`,
    NameSpins: `${EID_BASE}domain_spins_namespins`,
    SpinsValuationLink: {
      Click: `${EID_BASE}domain_spins.valuation_link.click`
    },
    SpinsExpand: {
      AdSpins: `${EID_BASE}domain_spins_ad.expand.click`,
      Spins: `${EID_BASE}domain_spins.expand.click`
    },
    SpinsCollapse: {
      AdSpins: `${EID_BASE}domain_spins_ad.collapse.click`,
      Spins: `${EID_BASE}domain_spins.collapse.click`
    },
    SpinsAddToCartButton: {
      AddClick: `${EID_BASE}addToCart.click`,
      RemoveClick: `${EID_BASE}removeFromCart.click`
    }
  },
  SpinsTabs: {
    ClickTabAllRecommendations: `${EID_BASE}domain_spins.tab.click`,
    ClickTabByEndings: `${EID_BASE}domain_spins_byendings.tab.click`,
    ClickTabNameSpins: `${EID_BASE}domain_spins_namespins.tab.click`
  },
  LoadMoreSpins: `${EID_BASE}button.load-more-spins`,
  MoreSpinsCount: `${EID_BASE}suggested_results_count`,
  Ai: {
    SpinsAiClick: `${EID_BASE}${EID_AI}expand.click`,
    Error: `${EID_BASE}${EID_AI}expand_error.impression`,
    AiErrorLinkClick: `${EID_BASE}${EID_AI}expand_error.click`,
    aiSearch: `${EID_BASE}aisearch`
  },
  MoreLikeThisSpins: {
    Impression: `${EID_BASE}more_like_this_spins.impression`,
    Click: `${EID_BASE}more_like_this_spins.click`,
    ErrorLinkClick: `${EID_BASE}more_like_this_spins.error_link.click`
  },
  MerchRecommend: {
    MerchRecommendAddToCart: `${EID_BASE}merchApiRecommendation`
  }
};